import { HttpClient, HttpParams } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { map, Observable } from "rxjs";
import { CommissionBonusDetailsPort } from "../../../app/ports/integration/commission-bonus-details.port";
import { CommissionBonusDetailsPageResponse } from "../../../domain/models/integration/commission-bonus-details.model";
import { EnvMicroIntegration } from "../../config/env.micro.integration";
import { INTEGRATION_ENV } from "../../config/micros-env.tokens";
import { isCommissionBonusDetailsPageResponse } from "../../validators/integration/commission-bonus-details.validator";

@Injectable()
export class CommissionBonusDetailsHttpAdapter implements CommissionBonusDetailsPort {
  private static readonly PATH = "/api/v1/commission-payables/bonus-details";
  constructor(private readonly http: HttpClient, @Inject(INTEGRATION_ENV) private readonly env: EnvMicroIntegration) {}

  getDetails(periodId: number, paidStatus: 0 | 1, page: number, size: number): Observable<CommissionBonusDetailsPageResponse> {
    const baseUrl = `${this.env.host}${this.env.apiBasePath}`.replace(/\/$/, "");
    const params = new HttpParams().set("periodIds", periodId).set("paidStatus", paidStatus).set("page", page).set("size", size);
    return this.http.get<unknown>(`${baseUrl}${CommissionBonusDetailsHttpAdapter.PATH}`, { params }).pipe(map((response) => {
      if (!isCommissionBonusDetailsPageResponse(response)) throw new Error("La respuesta del detalle de comisiones es inválida.");
      return response;
    }));
  }
}
